import React from "react";
import CommonButtons from "src/shared/components/CommonButtons";

interface Props {
  balance: string | number;
  onPay: () => void;
  onRefund: () => void;
}

const OutstandingCard: React.FC<Props> = ({ balance, onPay, onRefund }) => {
  const numericBalance = Number(balance);
  const isAdvance = numericBalance < 0;
  const amount = Math.abs(numericBalance);

  return (
    <div className="rounded-xl bg-white border border-slate-400/90 shadow-inner p-3">
      <div className="flex items-start justify-between mb-2">
        <div>
          <h2 className="text-base font-semibold text-gray-900">Balance Summary</h2>
          <p className="text-xs text-gray-500 mt-0.5">{isAdvance ? "Customer credit available" : "Pending payment"}</p>
        </div>

        <span className={`text-sm rounded-xl font-bold px-2 py-1 ${isAdvance ? "bg-emerald-50 border-emerald-200 text-emerald-700" : "bg-rose-50 border border-rose-200 text-rose-700"}`}>{isAdvance ? "Advance" : "Outstanding"}</span>
      </div>

      <div className="text-center mt-6">
        <div className={`text-5xl font-bold ${isAdvance ? "text-emerald-600" : "text-rose-600"}`}>{amount.toFixed(2)}</div>
      </div>

      {/* <div>
        {numericBalance > 0 ? (
          <CommonButtons label="Pay Now" onClick={onPay} className="w-full py-2.5 text-sm" />
        ) : (
          <CommonButtons label="Process Refund" onClick={onRefund} disabled className="w-full py-2.5 text-sm opacity-50" />
        )}
      </div> */}
    </div>
  );
};

export default OutstandingCard;
